// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
Vue.use(VueFire)

firebase.initializeApp({
  apiKey: "AIzaSyBDRAk7DxDSyG2MxRepd76BksLo3UbvDeg",
  authDomain: "visity-fcbd6.firebaseapp.com",
  databaseURL: "https://visity-fcbd6.firebaseio.com",
  projectId: "visity-fcbd6",
  storageBucket: "visity-fcbd6.appspot.com",
  messagingSenderId: "1042116357969",
  appId: "1:1042116357969:web:3836d0142503b635f2ad70"
})

export const db = firebase.firestore()

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js